import NumberMultipleCheckbox from 'components/ScalarSpreadsheet/components/number-multiple-checkbox/NumberMultipleCheckbox';
import { NumberMultipleCheckboxProps } from 'components/ScalarSpreadsheet/components/number-multiple-checkbox/NumberMultipleCheckbox.props';

// Separate checkbox component dedicated to the Cash Flow Ledger.
// It intentionally disables click-to-toggle on the value/label so that the CFL
// retains its "click the cell to reveal the checkbox, then click the checkbox"
// editing flow - leaving double-click free to open the amount editor without
// flipping the exclusion. Valuations multiples use NumberMultipleCheckbox directly
// (toggleOnLabelClick defaults to true), restoring their click-to-include/exclude.
const CflExclusionCheckbox = (props: NumberMultipleCheckboxProps) => (
  <NumberMultipleCheckbox {...props} toggleOnLabelClick={false} />
);

export default CflExclusionCheckbox;
